<template>
  <section>
    <a :href="indexData.index_top_pull[0].url" target="_blank" rel="noopener noreferrer">
      <img :src="indexData.index_top_pull[0].src" alt srcset class="topguanggao" />
    </a>
    <Header :indexData="indexData" :userInfo="userInfo" :keyword="keyword"></Header>
    <div class="banner">
      <div class="fbox" style="background: rgba(255,255,255,0.5);">
        <div>
          <div class="logininfo">
            <div class="touxiang">
              <img :src="userInfo.headimgurl||'/static/images/avatar.jpg'" alt="请上传头像" />
            </div>
            <div>
              <span class="color-primary" v-if="!userInfo.username">hi欢迎来到快力文</span>
              <div class="name">
                {{userInfo.username}}
                <a
                  v-if="userInfo.username"
                  href="#/login"
                  style="font-size: 12px;"
                >退出</a>
                <a v-else href="#/login" style="font-size: 12px;">登录</a>
                <a v-if="!userInfo.username" href="#/register" style="font-size: 12px;">注册</a>
              </div>
            </div>
          </div>
          <div class="kuaibao">
            <div class="hd clearfix mt10 mb20">
              <div class="tit">快讯</div>
              <div class>
                <a href="/category/1.html" class="color-000 fr">
                  更多
                  <i class="iconfont icon-right"></i>
                </a>
              </div>
            </div>
            <ul class="bd">
              <li
                v-for="(item,index) in indexData.index_info"
                :key="'key'+index"
                class="needspot flex"
              >
                <div class="dian"></div>
                <a :href="'/view/'+item.id+'.html'">{{item.title}}</a>
              </li>
            </ul>
          </div>
        </div>
        <ul class="clearlist clearfix gnft">
          <li>
            <a href="#/usercenter?type=1-1">
              <div class="icon">
                <i class="iconfont icon-order"></i>
              </div>
              <div class="tit">我的订单</div>
            </a>
          </li>
          <li>
            <a href="#/usercenter?type=2-3">
              <div class="icon">
                <i class="iconfont icon-star"></i>
              </div>
              <div class="tit">我的收藏</div>
            </a>
          </li>
          <li>
            <a href="#/usercenter?type=3-1" target="_blank">
              <div class="icon">
                <i class="iconfont icon-quan02"></i>
              </div>
              <div class="tit">我的优惠券</div>
            </a>
          </li>
        </ul>
      </div>
      <div class="bannercont" id="banner">
        <ul class="clearlist slides">
          <el-carousel :interval="5000" arrow="always" height="450px">
            <li v-for="(item,index) in indexData.index_banner" :key="'key'+index">
              <el-carousel-item>
                <a :href="item.url">
                  <img :src="item.src" />
                  <el-image :src="item.src" lazy></el-image>
                </a>
              </el-carousel-item>
            </li>
          </el-carousel>
        </ul>
      </div>
    </div>

    <div class="container">
      <div class="miaosha" v-if="indexData.index_group_list.length>0">
        <a class="hd" href="#/seckill">
          <div class="t1">商城秒杀</div>
          <div class="t2">FLASH DESLS</div>
          <div style=" margin: 15px 0;">
            <img src="/static/images/shandian.png" />
          </div>
          <div class style=" margin: 20px 0;">距离结束还差</div>
          <div class="time">
            <span class="item">{{count_time[0]}}</span>:
            <span class="item">{{count_time[1]}}</span>:
            <span class="item">{{count_time[2]}}</span>
          </div>
        </a>
        <div class="bd" id="miaosha" style="width:auto;max-width:1000px">
          <ul class="clearlist slides">
            <li v-for="(item,index) in indexData.index_group_list" :key="index">
              <a :href="'product/'+item.id+'.html'" class="cont" target="_blank">
                <div class="img">
                  <img class="hoverimg" :src="item.indexpic" />
                </div>
                <div class="tit ellipsis">{{item.title}}</div>
                <div class="jiage">
                  <span class="xianjia">¥{{item.price}}</span>
                  <span class="yuanjia">¥{{item.price1}}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="clearfix yhjzq" style=" margin-top: 30px;">
        <div class="zqtg" v-for="(item,index) in indexData.index_ad2" :key="'key'+index">
          <div class="hd clearfix">
            <span class="tit">{{item.remark}}</span>
            <a :href="item.url" class="more">更多</a>
          </div>
          <div class="bd">
            <a :href="item.url">
              <img class="hoverimg" :src="item.src" />
            </a>
          </div>
        </div>

        <div class="zqtg" style=" margin-right: 0;">
          <div class="hd clearfix">
            <span class="tit">领券中心</span>
            <a href="javascript:;" @click="yhjDialogVisible=true" class="more">更多</a>
          </div>
          <div class="bd">
            <div class="btnbox">
              <div class="quanitem" v-for="(item) in indexData.index_coupon_list" :key="item.id">
                <div class="ft">
                  <div class="tit">限时优惠</div>
                  <div style="font-size: 12px;">全店通用</div>
                  <div>
                    <a
                      href="javascript:;"
                      @click="getCoupon(item.id,item.isget)"
                      class="layui-btn layui-btn-primary layui-btn-radius layui-btn-sm"
                    >{{item.isget==0?'立即领取':'已领取'}}</a>
                  </div>
                </div>
                <div class="cont">
                  <div class="mianzhi">{{item.amount}}元优惠券</div>
                  <div class="manjian">全场满{{item.cost}}元可立即使用</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 办公用具 -->
      <div class="bgyj" style="height:40px;"></div>
      <div class="flex ju-be">
        <div class="goodslist remai" style="height:392px">
          <a class="goodslistDesc flex ju-be" href="javascript:;">
            <div>
              <span class="title">热卖推荐</span>
              <span class="desc">专属你的购物推荐</span>
            </div>
          </a>
          <div class>
            <div
              class="llwgoodsimg_name remaituijian"
              v-for="(item,index) in indexData.index_hot_list"
              :key="index"
            >
              <a :href="'product/'+item.id+'.html'" target="_blank">
                <div class="img">
                  <el-image class="hoverimg" :src="item.indexpic" lazy></el-image>
                </div>
                <div class="name ellipsis">{{item.title}}</div>
              </a>
            </div>
          </div>
        </div>
        <div>
          <div class="goodslist flex remai rexiao">
            <a class="goodslistDesc flex ju-be" href="javascript:;">
              <div>
                <span class="title">热销单品</span>
                <span class="desc">专属你的购物推荐</span>
              </div>
            </a>
            <a
              :href="'product/'+item.id+'.html'"
              target="_blank"
              class="llwgoodsimg_name flex"
              v-for="(item,index) in indexData.index_new_list"
              :key="'key'+item.id"
              v-if="index<2"
            >
              <div class="img">
                <img class="hoverimg" :src="item.indexpic" alt />
              </div>
              <div class="name_soucan ellipsis-2">
                <div class="name">{{item.title}}</div>
                <div class="name">{{item.favnum}}人收藏</div>
              </div>
            </a>
          </div>
          <div class="goodslist flex remai rexiao">
            <a class="goodslistDesc flex ju-be" href="javascript:;">
              <div>
                <span class="title">优选商品</span>
                <span class="desc">专属你的购物推荐</span>
              </div>
              <!-- <span class="desc">查看更多></span> -->
            </a>
            <a
              :href="'product/'+item.id+'.html'"
              target="_blank"
              class="llwgoodsimg_name flex"
              v-for="(item,index) in indexData.index_new_list"
              :key="'key'+item.id"
              v-if="index>1"
            >
              <div class="img">
                <img class="hoverimg" :src="item.indexpic" alt />
              </div>
              <div class="name_soucan ellipsis-2">
                <div class="name">{{item.title}}</div>
                <div class="name">{{item.favnum}}人收藏</div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div class="cpgroup" v-if="indexData.index_shop_self.length>0">
        <div class="gd">
          <a href="#/zhuanqu">
            <img class="hoverimg" :src="indexData.index_shop_self.adlist[0].src" />
          </a>
        </div>
        <div class="bd">
          <ul class="clearlist clearfix">
            <li class="imgbox">
              <a :href="indexData.index_shop_self.adlist[1].url">
                <img class="hoverimg" :src="indexData.index_shop_self.adlist[1].src" />
              </a>
            </li>
            <li class="item" v-for="(item,index) in indexData.index_shop_self.productlist">
              <a :href="'product/'+item.id+'.html'">
                <div class="img">
                  <img class="hoverimg" :src="item.indexpic" />
                </div>
                <div class="tit ellipsis-2">{{item.title}}</div>
                <div class="price">
                  <span class="xianjia">¥{{item.price}}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <!-- 楼层 -->
      <!-- 办公用纸 -->
      <div class="floor" v-for="(item,index) in indexData.index_floor_list" :key="index">
        <div class="caihd">{{item.name}}</div>
        <div class="cpgroup">
          <div class="gd">
            <a :href="item.linkurl">
              <img class="hoverimg" :src="item.indexpic" />
            </a>
          </div>

          <div class="bd flooorGoods" :id="index==0?'cainixihuanlist':''">
            <div style="overflow: hidden; position: relative;">
              <ul class="clearlist slides">
                <li
                  class="item"
                  style="margin-left: 0;"
                  v-for="(item_i,index_i) in item._child"
                  :key="index_i"
                >
                  <a :href="'product/'+item_i.id+'.html'" target="_blank">
                    <div class="img">
                      <el-image class="hoverimg" v-if="index==0" :src="item_i.indexpic" lazy></el-image>
                      <img class="hoverimg" v-else :src="item_i.indexpic" alt srcset />
                    </div>
                    <div class="tit ellipsis-2 textleft">{{item_i.title}}</div>
                    <div class="price">
                      <span class="xianjia">¥{{item_i.price}}</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 频道广播 -->
      <div class="caihd pindaogb">频道广播</div>
      <div class="flex ju-be ai-sr pdList">
        <div class="goodslist" v-for="(item) in indexData.index_channel_list" :key="item.id">
          <a class="goodslistDesc flex ju-be" :href="'#/goodsList?categoryid='+item.id">
            <div>
              <span class="title">{{item.name}}</span>
            </div>
            <span class="desc">查看更多></span>
          </a>
          <div class="llwgoodsimg_name" v-for="(item_i) in item._child" :key="item_i.id">
            <a :href="'product/'+item_i.id+'.html'" target="_blank" rel="noopener noreferrer">
              <div class="img">
                <!-- <img class="hoverimg" :src="item_i.indexpic" alt /> -->
                <el-image class="hoverimg" :src="item_i.indexpic" lazy></el-image>
              </div>
              <div class="name ellipsis">{{item_i.title}}</div>
            </a>
          </div>
        </div>
      </div>
      <div class="caihd cainilike">猜你喜欢</div>
      <div class="cpgroup">
        <div class="bd">
          <ul class="clearlist clearfix" id="cainixihuanlist" style="margin-left: -15px;">
            <li class="item" v-for="(item,index) in cainixihuan.data" :key="index">
              <a :href="'product/'+item.id+'.html'" target="_blank">
                <div class="img">
                  <!-- <img class="hoverimg" :src="item.indexpic" /> -->
                  <el-image class="hoverimg" :src="item.indexpic" lazy></el-image>
                </div>
                <div class="tit ellipsis-2">{{item.title}}</div>
                <div class="price">
                  <span class="xianjia">¥{{item.price}}</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer :indexData="indexData"></Footer>
    <transition name="el-fade-in-linear">
      <div class="nav_bar transition-box" v-if="shownav_bar">
        <li
          :class="index==active?'active item center':'item center'"
          @click="scrollTo(index)"
          v-for="(item,index) in navarr"
          :key="index"
        >{{item}}</li>
      </div>
    </transition>

    <div class="kuaijiemenu">
      <a :href="indexData.index_kefu" target="_blank" class="active">
        <li class="center">
          <span class="iconfont icon-lianxi"></span>
          <span>在线</span>
          <span>咨询</span>
        </li>
      </a>
      <a href="#/cart" class="car">
        <el-tooltip class="item" effect="dark" content="购物车" placement="left">
          <li class="center">
            <span class="iconfont icon-cart"></span>
            <span class="carnum">{{indexData.index_cartnum}}</span>
          </li>
        </el-tooltip>
      </a>
      <a href="javascript:;" class @click="yijian">
        <el-tooltip class="item" effect="dark" content="意见反馈" placement="left">
          <li class="center">
            <span class="iconfont icon-edit"></span>
          </li>
        </el-tooltip>
      </a>
      <a href="javascript:;" class @click="toTop">
        <li class="center">
          <span class="iconfont icon-up"></span>
        </li>
      </a>
    </div>
    <el-dialog title="意见反馈" :visible.sync="adviceFormVisible" destroy-on-close>
      <Advice @fatherMethod="closeAdviceBox"></Advice>
    </el-dialog>
    <el-drawer
      title="优惠券"
      :visible.sync="yhjDialogVisible"
      direction="rtl"
      custom-class="drawer"
      size="300"
    >
      <div class="couponModal">
        <!-- <div class="item-wrap" v-for="(item,index) in indexCoupons" :key="index">
          <div class="coupon-price">
            <span class="token">฿</span>
            <span class="coupon-val">{{item.amount}}</span>
           
          </div>
          <div class="coupon-info">
            <span class="condition" title>满฿{{item.cost}}可用</span>
            <span class="coupon-name color-red">限{{item.shopName||"平台自营"}}店铺使用</span>
          </div>
          <a
            href="javascript:;"
            class="btn-get"
            v-if="item.isget==0"
            @click="getCoupon(item.id,item.isget)"
          >立即领取</a>
          <a href="javascript:;" class="btn-get" v-else>已领取</a>
          <p class="coupon-time">有效期{{item.timefrom}}至{{item.timeto}}</p>
        </div>-->
        <div class="quanitem" style="margin:10px" v-for="(item) in indexCoupons" :key="item.id">
          <div class="ft">
            <div class="tit">限时优惠</div>
            <div style="font-size: 12px;">全店通用</div>
            <div>
              <a
                href="javascript:;"
                @click="getCoupon(item.id,item.isget)"
                class="layui-btn layui-btn-primary layui-btn-radius layui-btn-sm"
              >{{item.isget==0?'立即领取':'已领取'}}</a>
            </div>
          </div>
          <div class="cont">
            <div class="mianzhi">{{item.amount}}元优惠券</div>
            <div class="manjian">全场满{{item.cost}}元可立即使用</div>
          </div>
        </div>
      </div>
    </el-drawer>
  </section>
</template>
<script>
import Header from "../components/header";
import Footer from "../components/footer";
import Advice from "../components/advice";
export default {
  components: {
    Header,
    Footer,
    Advice
  },
  name: "index",
  data() {
    return {
      active: 0, // 当前激活的导航索引
      maodian: [],
      yhjDialogVisible: false,
      limit: 6,
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      adviceFormVisible: false,
      shownav_bar: false,
      navarr: [],
      count_time: ["00", "00", "00"],
      userInfo: {
        headimgurl: "",
        username: ""
      },
      indexCoupons: [],
      keyword: "",
      cainixihuan: {}, //猜你喜欢的数据
      indexData: {
        index_cartnum: 0,
        user: {},
        index_top_pull: [{ url: "", src: "" }],
        index_group_list: [],
        index_shop_self: {
          adlist: [
            { url: "", src: "" },
            { url: "", src: "" }
          ]
        }
      }
    };
  },
  methods: {
    someconfig() {},
    // 领取优惠券
    async getCoupon(batchid, isget) {
      if (!this.userInfo.username) {
        this.$confirm("请先登录！再领取优惠券", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showCancelButton: false,
          center: true
        })
          .then(() => {
            this.$router.push("/login");
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
      } else {
        if (isget == 1) {
          this.$message.error("你已经领取");
          return;
        }
        if (
          !(
            this.indexData.user.levelid == 1 &&
            this.indexData.user.companyid == 0
          )
        ) {
          this.$message({ message: "仅限普通用户可领取", type: "error" });
          return;
        }
        let res = await this.$fetch("member/getCoupon", {
          body: { batchid }
        });
        if (res) {
          this.$message({ message: "领取成功", type: "success" });
        }
        this.yhjDialogVisible = false;
        this.getIndexdata();
        this.getIndexCoupons();
      }
    },
    async getIndexCoupons() {
      this.indexCoupons = await this.$fetch("index/coupons", {
        body: { num: 0 }
      });
    },
    async getIndexdata() {
      let navarr = [];
      let that = this;
      this.indexData = await this.$fetch("Index/indexdata");
      if (this.indexData.index_group_list.length > 0) {
        let countTime =
          this.indexData.index_group_time.timeto -
          this.indexData.index_group_time.timefrom;
        let timeId = setInterval(function() {
          that.count_time = getDate(countTime);
          countTime--;
          if (countTime <= 0) {
            clearInterval(timeId);
          }
        }, 1000);
        this.timeId = timeId;
      }
      if (this.indexData.index_group_list.length > 0) {
        navarr.push("商城秒杀");
      }
      navarr.push("专区中心");
      navarr.push("办公用具");
      for (let i = 0; i < this.indexData.index_floor_list.length; i++) {
        navarr.push(this.indexData.index_floor_list[i].name);
      }
      navarr.push("频道广播");
      navarr.push("猜你喜欢");
      this.navarr = navarr;
      // let swpiergoods_arr = [];
      // let swpiergoods = this.indexData.index_floor_list[1]._child;
      // for (let i = 3; i < swpiergoods.length; i++) {
      //   swpiergoods_arr.push([]);
      // }

      // swpiergoods.map((item, index) => {
      //   if (index <= 3) {
      //     swpiergoods_arr[0].push(item);
      //   }else{
      //     let arr=swpiergoods_arr[index-3-1];
      //     arr.splice(0,1);arr.push(item)
      //     swpiergoods_arr[index-3]=arr
      //   }
      // });
      // console.log("swpiergoods_arr", swpiergoods_arr);
      // let obj=this.indexData;
      // obj.index_floor_list[1]._child=swpiergoods_arr;
      // this.indexData=obj;
      // // this.indexData.index_floor_list[1]._child=swpiergoods
      // console.log("swpiergoods_arr",obj.index_floor_list[1]._child);
    },

    // 滚动监听器
    onScroll() {
      const navContents = document.querySelectorAll(".content div");
      console.log("maodianmaodianmaodian", this.maodian[0].offsetTop);

      // 所有锚点元素的 offsetTop
      const offsetTopArr = [];
      this.maodian.forEach(item => {
        offsetTopArr.push(item.offsetTop);
      });
      // 获取当前文档流的 scrollTop
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义当前点亮的导航下标
      // console.log("scrollTop", scrollTop);
      let navIndex = 0;
      this.shownav_bar = scrollTop > this.maodian[0].offsetTop ? true : false;
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n] - 50) {
          navIndex = n;
          //  console.log(scrollTop,offsetTopArr,navIndex)
          // alert(1)
        }
      }
      this.active = navIndex;
    },
    // 跳转到指定索引的元素
    scrollTo(index) {
      // 获取目标的 offsetTop
      // css选择器是从 1 开始计数，我们是从 0 开始，所以要 +1
      // const targetOffsetTop = document.querySelector(
      //   `.content div:nth-child(${index + 1})`
      // ).offsetTop;
      console.log("this.maodian", this.maodian);
      const targetOffsetTop = this.maodian[index].offsetTop;

      // 获取当前 offsetTop
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉，步子迈大了会扯到蛋
      const STEP = 50;
      // 判断是往下滑还是往上滑
      if (scrollTop > targetOffsetTop) {
        // 往上滑
        smoothUp();
      } else {
        // 往下滑
        smoothDown();
      }
      // 定义往下滑函数
      function smoothDown() {
        if (scrollTop < targetOffsetTop) {
          if (targetOffsetTop - scrollTop >= STEP) {
            scrollTop += STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(smoothDown);
        }
      }
      // 定义往上滑函数
      function smoothUp() {
        if (scrollTop > targetOffsetTop) {
          if (scrollTop - targetOffsetTop >= STEP) {
            scrollTop -= STEP;
          } else {
            scrollTop = targetOffsetTop;
          }
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          requestAnimationFrame(smoothUp);
        }
      }
    },
    closeAdviceBox() {
      this.adviceFormVisible = false;
    },
    toTop() {
      let num = document.documentElement.scrollTop;
      let timeiD = setInterval(function() {
        num = num - 100;
        document.documentElement.scrollTop = num;
        console.log(num);
        if (num <= 0) {
          clearInterval(timeiD);
        }
      }, 20);
    },
    // 意见反馈
    yijian() {
      this.adviceFormVisible = true;
    },
    // 获取锚点
    getmaodianArr() {
      // 获取所有锚点元素
      let maodian = [];
      if (document.querySelector(".miaosha")) {
        maodian.push(document.querySelector(".miaosha"));
      }
      maodian.push(document.querySelector(".yhjzq"));
      maodian.push(document.querySelector(".bgyj"));
      maodian = [...maodian, ...document.querySelectorAll(".floor")];
      maodian.push(document.querySelector(".pindaogb"));
      maodian.push(document.querySelector(".cainilike"));
      this.maodian = maodian;
    }
  },
  async mounted() {
    await this.getIndexdata();
    let indexcity = await this.$fetch("index/getcity", {
      body: { guid: this.guid }
    });
    sessionStorage.city = indexcity.province + "." + indexcity.city;
    document.getElementById("address").innerHTML = sessionStorage.city;

    // 获取首页地方数据
    this.getIndexCoupons();
    this.guid = sessionStorage.guid;
    if (sessionStorage.user && sessionStorage.user != "undefined") {
      this.userInfo = JSON.parse(sessionStorage.user);
    }

    // 猜你喜欢
    this.cainixihuan = await this.$fetch("Shop/productlist", {
      body: {
        page: 1,
        pagesize: 5,
        guid: "",
        guess: 1
      }
    });

    $(".downmenu").removeClass("hide");
    // 监听滚动事件
    setTimeout(() => {
      this.getmaodianArr();
      window.addEventListener("scroll", this.onScroll, false);
      (function(m, ei, q, i, a, j, s) {
        m[i] =
          m[i] ||
          function() {
            (m[i].a = m[i].a || []).push(arguments);
          };
        (j = ei.createElement(q)), (s = ei.getElementsByTagName(q)[0]);
        j.async = true;
        j.charset = "UTF-8";
        j.src = "https://static.meiqia.com/dist/meiqia.js?_=t";
        s.parentNode.insertBefore(j, s);
      })(window, document, "script", "_MEIQIA");
      _MEIQIA("entId", 166919);
    }, 500);
    // 商品滚动效果
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
    clearInterval(this.timeId);
  },
  updated() {
    $(".flooorGoods").flexslider({
      animation: "slide",
      touch: 1,
      prevText: '<span class="iconfont icon-left"></span>',
      nextText: '<span class="iconfont icon-right"></span>',
      controlNav: false,
      move: 1,
      slideshow: true,
      slideshowSpeed: 2500, // 自动播放速度毫秒
      animationSpeed: 1000,
      pauseOnAction: false,
      itemMargin: 10,
      animationLoop: true,
      pauseOnHover: true,
      itemWidth: 237,
      minItems: 1,
      maxItems: 4,
      start: function(slider) {
        // console.log("slider.currentSlide", slider.flexAnimate(0));
      }
    });
  }
};
</script>


<style lang='scss' scoped>
.noScrolling {
  .item:nth-child(5n) {
    margin-left: 0 !important;
  }
  .item {
    margin-left: 22px !important;
    width: 222px !important;
  }
}
.topguanggao {
  width: 100%;
}
.el-carousel__item {
  height: 450px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__indicators {
  .el-carousel__indicator {
    margin-right: 10px !important;
  }
}
body {
  background: rgba(245, 245, 245, 1) !important;
}
.more {
  line-height: 55px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue